export const translations = {
  en: {
    // Meta tags
    title: "Namaste Doctor - Learn About Your Body",
    description: "Namaste Doctor is a safe, anonymous platform where adolescents can learn about sexual and reproductive health through verified, easy-to-understand information.",
    keywords: "sexual health education, reproductive health, adolescent health, puberty education, menstruation, anonymous health questions, Nepal health education",
    ogTitle: "Namaste Doctor - Learn About Your Body",
    ogDescription: "A safe, anonymous platform where adolescents can learn about sexual and reproductive health through verified information.",
    
    // Hero Section
    heroTitle: "Understanding Your Body Starts with the Right Questions",
    heroDescription: "Namaste Doctor is a safe, anonymous platform where adolescents can learn about sexual and reproductive health through verified, easy-to-understand information.",
    askAI: "Ask Our AI",
    askDoctor: "Ask a Doctor",
    heroNote: "Both options are private, anonymous, and educational only. No prescriptions or medical advice.",
    
    // Features Section
    featuresTitle: "Why Choose Namaste Doctor?",
    feature1Title: "Safe & Anonymous",
    feature1Desc: "Ask questions without revealing your identity. Your privacy is our priority. No registration, no tracking, no judgment—just honest answers when you need them.",
    feature2Title: "Verified Information",
    feature2Desc: "All content is reviewed by medical professionals and based on scientific evidence. We ensure every piece of information meets the highest standards of medical accuracy.",
    feature3Title: "Age-Appropriate",
    feature3Desc: "Content designed specifically for adolescents and young adults. Our information is tailored to your stage of life, using language that's clear, respectful, and easy to understand.",
    feature4Title: "Free Access",
    feature4Desc: "No cost, no registration required. Education should be accessible to all. We believe that accurate health information is a fundamental right, not a privilege.",
    
    // About Section
    aboutTitle: "About Namaste Doctor",
    aboutDescription: "Namaste Doctor was created to address the lack of comprehensive sexual and reproductive health education for adolescents in Nepal. We believe that accurate, stigma-free information is essential for young people to make informed decisions about their health and well-being.\n\nOur platform provides evidence-based information on topics including puberty, menstruation, sexual health, relationships, and more. All content is reviewed by qualified healthcare professionals to ensure accuracy and appropriateness.",
    founderInfo: "",
    
    // Posts Section
    postsTitle: "Latest Articles",
    post1Desc: "Learn about menstrual pain and how to manage it effectively.",
    post2Desc: "Understanding normal sexual development and addressing common concerns.",
    readMore: "Read More",
    
    // Doctors Section
    doctorsTitle: "Our Medical Team",
    doctor1Name: "Dr. Rochana Acharya",
    doctor1Specialty: "Gynecologist",
    doctor1Degree: "MD",
    doctor1Institution: "Cleveland Clinic Foundation Program",
    doctor1Role: "Medical Content Reviewer",
    doctor2Name: "Dr. Sagar Panthi",
    doctor2Specialty: "Urologist",
    doctor2Degree: "MD",
    doctor2Institution: "Texas Tech University Health Sciences Center",
    doctor2Role: "Medical Content Reviewer",
    viewAllDoctors: "View All Doctors",
    
    // How It Works Section
    howItWorksTitle: "How It Works",
    howTitle: "How It Works",
    howSubtitle: "Simple Steps to Get Started",
    howDescription: "Getting the information you need is easy and completely anonymous. We've designed our platform to be simple, straightforward, and accessible—no barriers, no complications.",
    step1Title: "Choose Your Path",
    step1Desc: "Start by selecting either our AI chatbot for instant answers or submit a question to our medical team. Both options are completely anonymous and designed to provide you with accurate, helpful information.",
    step2Title: "Ask Freely",
    step2Desc: "Type your questions without hesitation. There are no silly questions when it comes to your health. Our platform creates a judgment-free space where curiosity is encouraged and every question matters.",
    step3Title: "Get Verified Answers",
    step3Desc: "Receive clear, evidence-based responses reviewed by healthcare professionals. All information is tailored to be age-appropriate, medically accurate, and easy to understand.",
    step4Title: "Learn and Explore",
    step4Desc: "Browse our growing library of articles, resources, and educational content. Come back anytime—our platform is always here when you need reliable health information.",
    
    // How It Works Steps
    howStep1Title: "Choose Your Path",
    howStep1Desc: "Start by selecting either our AI chatbot for instant answers or submit a question to our medical team. Both options are completely anonymous and designed to provide you with accurate, helpful information.",
    howStep2Title: "Ask Freely",
    howStep2Desc: "Type your questions without hesitation. There are no silly questions when it comes to your health. Our platform creates a judgment-free space where curiosity is encouraged and every question matters.",
    howStep3Title: "Get Verified Answers",
    howStep3Desc: "Receive clear, evidence-based responses reviewed by healthcare professionals. All information is tailored to be age-appropriate, medically accurate, and easy to understand.",
    howStep4Title: "Learn and Explore",
    howStep4Desc: "Browse our growing library of articles, resources, and educational content. Come back anytime—our platform is always here when you need reliable health information.",
    
    // FAQ Section
    faqTitle: "Frequently Asked Questions",
    faq1Q: "Is my information really anonymous?",
    faq1A: "Yes, we don't collect any personal information that could identify you.",
    faq1Question: "Is my information really anonymous?",
    faq1Answer: "Yes, we don't collect any personal information that could identify you.",
    faq2Q: "Is the information medically accurate?",
    faq2A: "All content is reviewed by qualified healthcare professionals.",
    faq2Question: "Is the information medically accurate?",
    faq2Answer: "All content is reviewed by qualified healthcare professionals.",
    faq3Q: "What age group is this for?",
    faq3A: "Our content is designed for adolescents and young adults aged 13-25.",
    faq3Question: "What age group is this for?",
    faq3Answer: "Our content is designed for adolescents and young adults aged 11-20.",
    
    // Footer
    footerText: "© 2024 Namaste Doctor | Privacy Policy",
    
    // Navigation
    about: "About",
    posts: "Posts",
    howItWorks: "How It Works",
    faq: "FAQ",
    ourDoctors: "Our Doctors",
    chatbot: "Chatbot",
    contact: "Contact",
    doctorsLogin: "Doctors Login",
    
    // Language Toggle
    switchToNepali: "नेपालीमा पढ्नुहोस्",
    switchToEnglish: "Read in English",
    
    // Blog Content - Post 1 (Period Cramps)
    post1Title: "Understanding Period Cramps: Why They Happen and How to Feel Better",
    post1Published: "Published on:",
    post1By: "By:",
    post1Date: "March 20, 2025",
    post1Author: "Dr. Rochana Acharya",
    post1Heading1: "🌸 Period Pain? You're Not Alone! 🌸",
    post1Para1: "Did you know that 45% to 95% of girls and women who have periods experience period pain? So if you feel cramps in your lower belly during your periods, you are definitely not alone! This kind of pain usually starts on the first day of your period and can last up to 2 or 3 days. Some girls also feel pain in their lower back or thighs.",
    post1Para2: "But it's not just about cramps. During your period, you might feel tired, have a headache, feel nauseous (like you want to throw up), have loose stools, or notice mood swings like feeling irritated, sad, or anxious. These are common and normal, so don't worry—you are not alone in feeling this way.",
    post1Heading2: "Why Does This Happen?",
    post1Para3: "During your period, the lining of your uterus (womb) breaks down and comes out as period blood. To push it out, your uterus squeezes or cramps. That squeezing is what causes the pain. Your body also makes natural chemicals called prostaglandins to help with this process. But sometimes, your body makes too much of it, and the squeezing gets stronger, causing more pain. Hormone changes during your period can also make you feel more emotional.",
    post1Heading3: "How Do You Know If It's Normal Pain?",
    post1Para4: "This normal period pain is called primary dysmenorrhea. You can recognize it because:",
    post1List1: [
      "It usually starts a year or two after your first period.",
      "It happens during your periods and gets better after 2 or 3 days.",
      "There's no other health problem causing it.",
      "It often improves as you get older or after having a baby."
    ],
    post1Heading4: "What Can You Do to Feel Better?",
    post1Para5: "The good news is there are simple ways to manage the pain!",
    post1List2: [
      "Put a warm cloth or heating pad on your lower belly.",
      "Do some light exercise like walking or stretching.",
      "Relax and rest when you need to.",
      "Pain relief medicines like ibuprofen can help. They work by reducing prostaglandins, the chemical that causes strong cramps. These medicines are safe when used correctly—they won't mess up your future periods or health. That's why it's important to follow the right dose, and your doctor can help with that."
    ],
    post1Quote: "So next time your belly hurts during your period, remember—you understand what's happening, and you've got ways to handle it! 🌸💪",
    
    // Blog Content - Post 2 (Masturbation)
    post2Title: "Understanding Masturbation: Facts, Myths, and Health Implications",
    post2Published: "Published on:",
    post2By: "By:",
    post2Date: "March 20, 2025",
    post2Author: "Dr. Rochana Acharya",
    post2Heading1: "Is Masturbation Harmful?",
    post2Para2: "No, masturbation does not cause physical harm. There is no scientific evidence linking it to negative effects on the body or reproductive health. In fact, studies suggest several benefits, such as:",
    post2List1: [
      "Stress relief",
      "Improved sleep",
      "Better understanding of one's own body and preferences"
    ],
    post2Para3: "However, if it becomes compulsive and begins to interfere with school, work, or relationships, it may indicate an underlying issue that should be addressed.",
    post2Heading2: "The Science Behind Masturbation",
    post2Para4: "Research shows that masturbation is a normal part of human development and sexual expression.",
    post2Para5: "Physical Benefits: Studies indicate that regular masturbation can have positive effects on physical health.",
    post2Para6: "Mental Health Benefits: Masturbation can also have antidepressant and anti-anxiety effects due to the release of endorphins.",
    post2Para7: "Psychological Benefits: Masturbation can also have antidepressant and anti-anxiety effects due to the release of endorphins and other mood-enhancing hormones.",
    post2Heading4: "Common Myths Debunked",
    post2List2: [
      "\"Masturbation causes blindness or infertility\": False. No scientific link exists between masturbation and these effects.",
      "\"It lowers testosterone and weakens the body\": Partially false. While testosterone levels may dip briefly after ejaculation, they return to normal quickly.",
      "\"It leads to mental health problems\": False. Masturbation can actually reduce stress and support emotional well-being."
    ],
    post2Heading5: "Potential Risks of Excessive Masturbation",
    post2Para8: "While masturbation is generally safe, doing it excessively may come with certain risks:",
    post2List3: [
      "Mental Health Concerns: Some studies associate frequent masturbation with depressive symptoms, anxiety, and dissatisfaction with relationships.",
      "Physical Health Concerns: Research links high frequency of masturbation to elevated prostate-specific antigen levels.",
      "Behavioral Issues: Compulsive masturbation may negatively affect productivity, focus, and social interactions."
    ],
    post2Heading6: "The Role of Individual Differences",
    post2Para9: "Age and Development: The frequency and meaning of masturbation can vary significantly across different life stages.",
    post2Para10: "Cultural and Religious Factors: Personal beliefs and cultural background play a significant role in how individuals perceive and experience masturbation.",
    post2Para11: "Gender Differences: Research shows that the psychological effects of masturbation are not significantly influenced by gender.",
    post2Heading7: "Rare but Serious Risks",
    post2List4: [
      "Fournier's Gangrene: Though extremely rare, one case linked this serious infection to excessive masturbation using soap as a lubricant.",
      "Prostate Dysfunction: High-frequency masturbation may be associated with raised prostate-specific antigen levels and potential dysfunction.",
      "Sexual Dysfunction: Excessive masturbation can impact sexual satisfaction and intimacy with partners."
    ],
    post2Heading8: "Final Thoughts: A Balanced Approach",
    post2Para12: "As a future surgeon and researcher, I support evidence-based sexual health education. In moderation, masturbation is a healthy and normal part of development.",
    post2Quote: "By providing accurate, stigma-free education and addressing concerns with facts, we can help young people develop a healthy, guilt-free understanding of their bodies and sexuality.",
    backToPosts: "← Back to Posts"
  },
  
  ne: {
    // Meta tags
    title: "नमस्ते डाक्टर - आफ्नो शरीर बुझ्नुहोस्",
    description: "नमस्ते डाक्टर एक सुरक्षित, अनामिक मञ्च हो जहाँ किशोर-किशोरीहरूले प्रमाणित, सजिलो बुझिने जानकारीको माध्यमबाट यौन र प्रजनन स्वास्थ्यको बारेमा सिक्न सक्छन्।",
    keywords: "यौन स्वास्थ्य शिक्षा, प्रजनन स्वास्थ्य, किशोर स्वास्थ्य, यौवन शिक्षा, महिनावारी, अनामिक स्वास्थ्य प्रश्नहरू, नेपाल स्वास्थ्य शिक्षा",
    ogTitle: "नमस्ते डाक्टर - आफ्नो शरीर बुझ्नुहोस्",
    ogDescription: "एक सुरक्षित, अनामिक मञ्च जहाँ किशोर-किशोरीहरूले प्रमाणित जानकारीको माध्यमबाट यौन र प्रजनन स्वास्थ्यको बारेमा सिक्न सक्छन्।",
    
    // Hero Section
    heroTitle: "आफ्नो शरीर बुझ्नु सही प्रश्नहरूबाट सुरु हुन्छ",
    heroDescription: "नमस्ते डाक्टर एक सुरक्षित, अनामिक मञ्च हो जहाँ किशोर-किशोरीहरूले प्रमाणित, सजिलो बुझिने जानकारीको माध्यमबाट यौन र प्रजनन स्वास्थ्यको बारेमा सिक्न सक्छन्।",
    askAI: "हाम्रो AI सँग सोध्नुहोस्",
    askDoctor: "डाक्टरसँग सोध्नुहोस्",
    heroNote: "दुबै विकल्प निजी, अनामिक र शैक्षिक मात्र हुन्। कुनै पनि पर्ची वा परामर्श छैन।",
    
    // Features Section
    featuresTitle: "किन नमस्ते डाक्टर छान्ने?",
    feature1Title: "सुरक्षित र अनामिक",
    feature1Desc: "आफ्नो पहिचान नखोलेर प्रश्नहरू सोध्नुहोस्। तपाईंको गोपनीयता हाम्रो प्राथमिकता हो। कुनै दर्ता छैन, कुनै ट्र्याकिङ छैन, कुनै निर्णय छैन—तपाईंलाई आवश्यक पर्दा केवल इमानदार जवाफहरू।",
    feature2Title: "प्रमाणित जानकारी",
    feature2Desc: "सबै सामग्री चिकित्सा पेशेवरहरूद्वारा समीक्षा गरिएको छ र वैज्ञानिक प्रमाणमा आधारित छ। हामी प्रत्येक जानकारीले चिकित्सा सटीकताको उच्चतम मापदण्ड पूरा गर्ने कुरा सुनिश्चित गर्छौं।",
    feature3Title: "उमेर-उपयुक्त",
    feature3Desc: "किशोर र युवा वयस्कहरूका लागि विशेष रूपमा डिजाइन गरिएको सामग्री। हाम्रो जानकारी तपाईंको जीवन चरणको लागि अनुकूलित छ, जुन स्पष्ट, सम्मानजनक र बुझ्न सजिलो भाषा प्रयोग गर्दछ।",
    feature4Title: "निःशुल्क पहुँच",
    feature4Desc: "कुनै लागत छैन, कुनै दर्ता आवश्यक छैन। शिक्षा सबैका लागि सुलभ हुनुपर्छ। हामी विश्वास गर्छौं कि सही स्वास्थ्य जानकारी मौलिक अधिकार हो, विशेषाधिकार होइन।",
    
    // About Section
    aboutTitle: "नमस्ते डाक्टरको बारेमा",
    aboutDescription: "नमस्ते डाक्टर नेपालमा किशोर-किशोरीहरूका लागि व्यापक यौन र प्रजनन स्वास्थ्य शिक्षाको कमीको समाधान गर्न सिर्जना गरिएको हो। हामी विश्वास गर्छौं कि सही, कलंक-मुक्त जानकारी युवाहरूका लागि आफ्नो स्वास्थ्य र कल्याणको बारेमा सूचित निर्णय लिन आवश्यक छ।\n\nहाम्रो मञ्चले यौवन, महिनावारी, यौन स्वास्थ्य, सम्बन्धहरू र अधिक विषयहरूमा प्रमाण-आधारित जानकारी प्रदान गर्छ। सबै सामग्री सटीकता र उपयुक्तताको ग्यारेन्टीका लागि योग्य स्वास्थ्य सेवा पेशेवरहरूद्वारा समीक्षा गरिएको छ।",
    founderInfo: "",
    
    // Posts Section
    postsTitle: "नयाँ लेखहरू",
    post1Desc: "महिनावारीको दुखाइ र यसलाई प्रभावकारी रूपमा कसरी व्यवस्थापन गर्ने बारेमा सिक्नुहोस्।",
    post2Desc: "सामान्य यौन विकास बुझ्नुहोस् र सामान्य चिन्ताहरूको सम्बोधन गर्नुहोस्।",
    readMore: "थप पढ्नुहोस्",
    
    // Doctors Section
    doctorsTitle: "हाम्रो चिकित्सा टोली",
    doctor1Name: "डा. रोचना आचार्य",
    doctor1Specialty: "स्त्री रोग विशेषज्ञ",
    doctor1Degree: "MD",
    doctor1Institution: "क्लीभल्याण्ड क्लिनिक फाउन्डेसन कार्यक्रम",
    doctor1Role: "चिकित्सा सामग्री समीक्षक",
    doctor2Name: "डा. सागर पन्थी",
    doctor2Specialty: "मूत्र रोग विशेषज्ञ",
    doctor2Degree: "MD",
    doctor2Institution: "टेक्सास टेक विश्वविद्यालय स्वास्थ्य विज्ञान केन्द्र",
    doctor2Role: "चिकित्सा सामग्री समीक्षक",
    viewAllDoctors: "सबै डाक्टरहरू हेर्नुहोस्",
    
    // How It Works Section
    howItWorksTitle: "यो कसरी काम गर्छ",
    howTitle: "यो कसरी काम गर्छ",
    howSubtitle: "सुरु गर्न सजिलो चरणहरू",
    howDescription: "तपाईंलाई चाहिने जानकारी पाउनु सजिलो र पूर्ण रूपमा अनामिक छ। हामीले हाम्रो मञ्चलाई सरल, सीधा र सुलभ हुने गरी डिजाइन गरेका छौं—कुनै बाधा छैन, कुनै जटिलता छैन।",
    step1Title: "आफ्नो बाटो छान्नुहोस्",
    step1Desc: "तुरुन्त जवाफको लागि हाम्रो AI च्याटबट वा हाम्रो चिकित्सा टोलीलाई प्रश्न पेश गर्नुहोस्। दुबै विकल्प पूर्ण रूपमा अनामिक छन् र तपाईंलाई सही, उपयोगी जानकारी प्रदान गर्न डिजाइन गरिएका छन्।",
    step2Title: "स्वतन्त्र रूपमा सोध्नुहोस्",
    step2Desc: "कुनै हिचकिचाहट बिना आफ्ना प्रश्नहरू टाइप गर्नुहोस्। तपाईंको स्वास्थ्यको कुरा आउँदा कुनै मूर्ख प्रश्नहरू छैनन्। हाम्रो मञ्चले निर्णय-मुक्त स्थान सिर्जना गर्छ जहाँ जिज्ञासालाई प्रोत्साहित गरिन्छ र प्रत्येक प्रश्न महत्वपूर्ण हुन्छ।",
    step3Title: "प्रमाणित उत्तरहरू पाउनुहोस्",
    step3Desc: "स्वास्थ्य सेवा पेशेवरहरूद्वारा समीक्षा गरिएका स्पष्ट, प्रमाण-आधारित प्रतिक्रियाहरू प्राप्त गर्नुहोस्। सबै जानकारी उमेर-उपयुक्त, चिकित्सकीय रूपमा सही र बुझ्न सजिलो हुने गरी अनुकूलित गरिएको छ।",
    step4Title: "सिक्नुहोस् र अन्वेषण गर्नुहोस्",
    step4Desc: "हाम्रो बढ्दो लेख, स्रोतहरू र शैक्षिक सामग्रीको पुस्तकालय ब्राउज गर्नुहोस्। कुनै पनि समयमा फर्कनुहोस्—तपाईंलाई भरपर्दो स्वास्थ्य जानकारी आवश्यक पर्दा हाम्रो मञ्च सधैं यहाँ छ।",
    
    // How It Works Steps
    howStep1Title: "आफ्नो बाटो छान्नुहोस्",
    howStep1Desc: "तुरुन्त जवाफको लागि हाम्रो AI च्याटबट वा हाम्रो चिकित्सा टोलीलाई प्रश्न पेश गर्नुहोस्। दुबै विकल्प पूर्ण रूपमा अनामिक छन् र तपाईंलाई सही, उपयोगी जानकारी प्रदान गर्न डिजाइन गरिएका छन्।",
    howStep2Title: "स्वतन्त्र रूपमा सोध्नुहोस्",
    howStep2Desc: "कुनै हिचकिचाहट बिना आफ्ना प्रश्नहरू टाइप गर्नुहोस्। तपाईंको स्वास्थ्यको कुरा आउँदा कुनै मूर्ख प्रश्नहरू छैनन्। हाम्रो मञ्चले निर्णय-मुक्त स्थान सिर्जना गर्छ जहाँ जिज्ञासालाई प्रोत्साहित गरिन्छ र प्रत्येक प्रश्न महत्वपूर्ण हुन्छ।",
    howStep3Title: "प्रमाणित उत्तरहरू पाउनुहोस्",
    howStep3Desc: "स्वास्थ्य सेवा पेशेवरहरूद्वारा समीक्षा गरिएका स्पष्ट, प्रमाण-आधारित प्रतिक्रियाहरू प्राप्त गर्नुहोस्। सबै जानकारी उमेर-उपयुक्त, चिकित्सकीय रूपमा सही र बुझ्न सजिलो हुने गरी अनुकूलित गरिएको छ।",
    howStep4Title: "सिक्नुहोस् र अन्वेषण गर्नुहोस्",
    howStep4Desc: "हाम्रो बढ्दो लेख, स्रोतहरू र शैक्षिक सामग्रीको पुस्तकालय ब्राउज गर्नुहोस्। कुनै पनि समयमा फर्कनुहोस्—तपाईंलाई भरपर्दो स्वास्थ्य जानकारी आवश्यक पर्दा हाम्रो मञ्च सधैं यहाँ छ।",
    
    // FAQ Section
    faqTitle: "बारम्बार सोधिने प्रश्नहरू",
    faq1Q: "के मेरो जानकारी वास्तवमै अनामिक छ?",
    faq1A: "हो, हामीले तपाईंलाई पहिचान गर्न सक्ने कुनै पनि व्यक्तिगत जानकारी सङ्कलन गर्दैनौं।",
    faq1Question: "के मेरो जानकारी वास्तवमै अनामिक छ?",
    faq1Answer: "हो, हामीले तपाईंलाई पहिचान गर्न सक्ने कुनै पनि व्यक्तिगत जानकारी सङ्कलन गर्दैनौं।",
    faq2Q: "के जानकारी चिकित्सकीय रूपमा सही छ?",
    faq2A: "सबै सामग्री योग्य स्वास्थ्य सेवा पेशेवरहरूद्वारा समीक्षा गरिएको छ।",
    faq2Question: "के जानकारी चिकित्सकीय रूपमा सही छ?",
    faq2Answer: "सबै सामग्री योग्य स्वास्थ्य सेवा पेशेवरहरूद्वारा समीक्षा गरिएको छ।",
    faq3Q: "यो कुन उमेर समूहका लागि हो?",
    faq3A: "हाम्रो सामग्री १३-२५ वर्षका किशोर र युवा वयस्कहरूका लागि डिजाइन गरिएको छ।",
    faq3Question: "यो कुन उमेर समूहका लागि हो?",
    faq3Answer: "हाम्रो सामग्री १३-२५ वर्षका किशोर र युवा वयस्कहरूका लागि डिजाइन गरिएको छ।",
    
    // Footer
    footerText: "© २०२४ नमस्ते डाक्टर | गोपनीयता नीति",
    
    // Navigation
    about: "बारेमा",
    posts: "लेखहरू",
    howItWorks: "कसरी काम गर्छ",
    faq: "सामान्य प्रश्न",
    ourDoctors: "हाम्रा डाक्टरहरू",
    chatbot: "च्याटबट",
    contact: "सम्पर्क",
    doctorsLogin: "डाक्टर लगइन",
    
    // Language Toggle
    switchToNepali: "नेपालीमा पढ्नुहोस्",
    switchToEnglish: "Read in English",
    
    // Blog Content - Post 1 (Period Cramps) in Nepali
    post1Title: "महिनावारीको दुखाइ बुझ्नुहोस्: किन हुन्छ र कसरी राम्रो महसुस गर्ने",
    post1Published: "प्रकाशित:",
    post1By: "लेखक:",
    post1Date: "मार्च २०, २०२५",
    post1Author: "डा. रोचना आचार्य",
    post1Heading1: "🌸 महिनावारीको दुखाइ? तपाईं एक्लै हुनुहुन्न! 🌸",
    post1Para1: "के तपाईंलाई थाहा छ कि महिनावारी हुने ४५% देखि ९५% केटी र महिलाहरूले महिनावारीको दुखाइ अनुभव गर्छन्? त्यसैले यदि तपाईंले आफ्नो महिनावारीको समयमा तल्लो पेटमा दुखाइ महसुस गर्नुहुन्छ भने, तपाईं निश्चित रूपमा एक्लै हुनुहुन्न! यस्तो दुखाइ सामान्यतया तपाईंको महिनावारीको पहिलो दिन सुरु हुन्छ र २ वा ३ दिनसम्म रहन सक्छ। केही केटीहरूले आफ्नो तल्लो पछाडि वा जाँघमा पनि दुखाइ महसुस गर्छन्।",
    post1Para2: "तर यो केवल दुखाइको कुरा मात्र होइन। तपाईंको महिनावारीको समयमा, तपाईंले थकान महसुस गर्न सक्नुहुन्छ, टाउको दुख्न सक्छ, मतली (उल्टी आउने जस्तो) महसुस गर्न सक्नुहुन्छ, पातलो दिसा हुन सक्छ, वा मनोदशा परिवर्तन जस्तै चिढाउने, दुःखी वा चिन्तित महसुस गर्न सक्नुहुन्छ। यी सबै सामान्य र साधारण हुन्, त्यसैले चिन्ता नगर्नुहोस्—तपाईं यसरी महसुस गर्नु एक्लै हुनुहुन्न।",
    post1Heading2: "यो किन हुन्छ?",
    post1Para3: "तपाईंको महिनावारीको समयमा, तपाईंको गर्भाशय (पेट)को भित्री तह टुट्छ र महिनावारीको रगतको रूपमा बाहिर आउँछ। यसलाई बाहिर धकेल्न, तपाईंको गर्भाशय निचोर्छ वा क्र्याम्प गर्छ। त्यो निचोर्ने क्रियाले दुखाइ ल्याउँछ। तपाईंको शरीरले यो प्रक्रियामा मद्दत गर्न प्राकृतिक रसायनहरू पनि बनाउँछ जसलाई प्रोस्टाग्लान्डिन भनिन्छ। तर कहिलेकाहीँ, तपाईंको शरीरले यो धेरै बनाउँछ, र निचोर्ने क्रिया बलियो हुन्छ, जसले धेरै दुखाइ ल्याउँछ। तपाईंको महिनावारीको समयमा हर्मोन परिवर्तनले तपाईंलाई धेरै भावनात्मक महसुस गराउन सक्छ।",
    post1Heading3: "यो सामान्य दुखाइ हो कि कसरी थाहा पाउनुहुन्छ?",
    post1Para4: "यो सामान्य महिनावारीको दुखाइलाई प्राथमिक डिसमेनोरिया भनिन्छ। तपाईंले यसलाई यसरी पहिचान गर्न सक्नुहुन्छ:",
    post1List1: [
      "यो सामान्यतया तपाईंको पहिलो महिनावारीको एक वा दुई वर्ष पछि सुरु हुन्छ।",
      "यो तपाईंको महिनावारीको समयमा हुन्छ र २ वा ३ दिन पछि राम्रो हुन्छ।",
      "यसलाई ल्याउने कुनै अन्य स्वास्थ्य समस्या छैन।",
      "यो प्रायः तपाईं बढ्दै जानुसँग वा बच्चा जन्माउनु पछि राम्रो हुन्छ।"
    ],
    post1Heading4: "राम्रो महसुस गर्न तपाईंले के गर्न सक्नुहुन्छ?",
    post1Para5: "राम्रो समाचार यो हो कि दुखाइ व्यवस्थापन गर्न सजिलो तरिकाहरू छन्!",
    post1List2: [
      "तपाईंको तल्लो पेटमा न्यानो कपडा वा हिटिंग प्याड राख्नुहोस्।",
      "हिँड्ने वा स्ट्रेचिंग जस्ता हल्का व्यायाम गर्नुहोस्।",
      "आवश्यकता अनुसार आराम गर्नुहोस् र विश्राम गर्नुहोस्।",
      "आइबुप्रोफेन जस्ता दुखाइ निवारक औषधिहरूले मद्दत गर्न सक्छन्। यी औषधिहरूले प्रोस्टाग्लान्डिन कम गरेर काम गर्छन्, जुन बलियो क्र्याम्पहरू ल्याउँछ। यी औषधिहरू सही तरिकाले प्रयोग गर्दा सुरक्षित हुन्—यीले तपाईंको भविष्यका महिनावारीहरू वा स्वास्थ्यलाई बिगार्ने छैनन्। त्यसैले सही मात्रा अनुसरण गर्नु महत्वपूर्ण छ, र तपाईंको डाक्टरले यसमा मद्दत गर्न सक्छन्।"
    ],
    post1Quote: "त्यसैले अर्को पटक तपाईंको महिनावारीको समयमा पेट दुख्यो भने, याद गर्नुहोस्—तपाईंले के भइरहेको छ भन्ने बुझ्नुहुन्छ, र तपाईंसँग यसलाई सामना गर्ने तरिकाहरू छन्! 🌸💪",
    
    // Blog Content - Post 2 (Masturbation) in Nepali
    post2Title: "हस्तमैथुन बुझ्नुहोस्: तथ्यहरू, मिथकहरू र स्वास्थ्य प्रभावहरू",
    post2Published: "प्रकाशित:",
    post2By: "लेखक:",
    post2Date: "मार्च २०, २०२५",
    post2Author: "डा. रोचना आचार्य",
    post2Heading1: "के हस्तमैथुन हानिकारक छ?",
    post2Para2: "होइन, हस्तमैथुनले शारीरिक हानि गर्दैन। यसले शरीर वा प्रजनन स्वास्थ्यमा नकारात्मक प्रभाव पार्ने भन्ने कुनै वैज्ञानिक प्रमाण छैन। वास्तवमा, अध्ययनहरूले धेरै फाइदाहरू सुझाव दिन्छन्, जस्तै:",
    post2List1: [
      "तनाव निवारण",
      "निद्रा सुधार",
      "आफ्नो शरीर र प्राथमिकताहरूको राम्रो बुझाइ"
    ],
    post2Para3: "तर यदि यो बाध्यकारी बन्छ र स्कूल, काम वा सम्बन्धहरूमा हस्तक्षेप गर्न सुरु गर्छ भने, यसले अन्तर्निहित समस्या जनाउन सक्छ जसलाई सम्बोधन गर्नुपर्छ।",
    post2Heading2: "हस्तमैथुनको पछाडिको विज्ञान",
    post2Para4: "अनुसन्धानले देखाउँछ कि हस्तमैथुन मानव विकास र यौन अभिव्यक्तिको सामान्य भाग हो।",
    post2Para5: "शारीरिक फाइदाहरू: अध्ययनहरूले नियमित हस्तमैथुनले शारीरिक स्वास्थ्यमा सकारात्मक प्रभाव पार्न सक्छ भन्ने देखाउँछ।",
    post2Para6: "मानसिक स्वास्थ्य फाइदाहरू: हस्तमैथुनले एन्डोर्फिन रिलिजको कारणले एन्टिडिप्रेसेन्ट र एन्टि-एन्जाइटी प्रभाव पनि हुन सक्छ।",
    post2Para7: "मनोवैज्ञानिक फाइदाहरू: हस्तमैथुनले एन्डोर्फिन र अन्य मनोदशा सुधारने हर्मोनहरूको रिलिजको कारणले एन्टिडिप्रेसेन्ट र एन्टि-एन्जाइटी प्रभाव पनि हुन सक्छ।",
    post2Heading4: "सामान्य मिथकहरू खण्डन",
    post2List2: [
      "\"हस्तमैथुनले अन्धपन वा बाँझपन ल्याउँछ\": गलत। हस्तमैथुन र यी प्रभावहरू बीच कुनै वैज्ञानिक सम्बन्ध छैन।",
      "\"यसले टेस्टोस्टेरोन कम गर्छ र शरीर कमजोर बनाउँछ\": आंशिक रूपमा गलत। जबकि टेस्टोस्टेरोन स्तरहरू स्खलन पछि छोटो समयका लागि घट्न सक्छ, तिनीहरू छिटै सामान्यमा फर्किन्छन्।",
      "\"यसले मानसिक स्वास्थ्य समस्याहरू ल्याउँछ\": गलत। हस्तमैथुनले वास्तवमा तनाव कम गर्न सक्छ र भावनात्मक कल्याणलाई समर्थन गर्न सक्छ।"
    ],
    post2Heading5: "अत्यधिक हस्तमैथुनका सम्भावित जोखिमहरू",
    post2Para8: "जबकि हस्तमैथुन सामान्यतया सुरक्षित छ, यसलाई अत्यधिक गर्दा केही जोखिमहरू हुन सक्छन्:",
    post2List3: [
      "मानसिक स्वास्थ्य चिन्ताहरू: केही अध्ययनहरूले बारम्बार हस्तमैथुनलाई अवसादग्रस्त लक्षणहरू, चिन्ता र सम्बन्धहरूसँग असन्तुष्टिका साथ जोड्छन्।",
      "शारीरिक स्वास्थ्य चिन्ताहरू: अनुसन्धानले हस्तमैथुनको उच्च आवृत्तिलाई उच्च प्रोस्टेट-विशिष्ट एन्टिजेन स्तरहरूसँग जोड्छ।",
      "व्यवहारिक समस्याहरू: बाध्यकारी हस्तमैथुनले उत्पादकता, फोकस र सामाजिक अन्तरक्रियाहरूमा नकारात्मक प्रभाव पार्न सक्छ।"
    ],
    post2Heading6: "व्यक्तिगत भिन्नताहरूको भूमिका",
    post2Para9: "उमेर र विकास: हस्तमैथुनको आवृत्ति र अर्थ विभिन्न जीवन चरणहरूमा महत्वपूर्ण रूपमा फरक हुन सक्छ।",
    post2Para10: "सांस्कृतिक र धार्मिक कारकहरू: व्यक्तिगत विश्वासहरू र सांस्कृतिक पृष्ठभूमिले व्यक्तिहरूले हस्तमैथुनलाई कसरी बुझ्छन् र अनुभव गर्छन् भन्नेमा महत्वपूर्ण भूमिका खेल्छ।",
    post2Para11: "लिङ्ग भिन्नताहरू: अनुसन्धानले देखाउँछ कि हस्तमैथुनका मनोवैज्ञानिक प्रभावहरू लिङ्गद्वारा महत्वपूर्ण रूपमा प्रभावित हुँदैनन्।",
    post2Heading7: "दुर्लभ तर गम्भीर जोखिमहरू",
    post2List4: [
      "फोर्नियर ग्याङ्ग्रिन: यद्यपि अत्यन्त दुर्लभ, एक केसमा यो गम्भीर संक्रमणलाई साबुनलाई लुब्रिकेन्टको रूपमा प्रयोग गरेर अत्यधिक हस्तमैथुनसँग जोडिएको थियो।",
      "प्रोस्टेट दुष्क्रिया: उच्च-आवृत्ति हस्तमैथुनले उच्च प्रोस्टेट-विशिष्ट एन्टिजेन स्तरहरूसँग सम्बन्धित हुन सक्छ र सम्भावित दुष्क्रिया।",
      "यौन दुष्क्रिया: अत्यधिक हस्तमैथुनले यौन सन्तुष्टि र साझेदारहरूसँगको घनिष्ठतामा प्रभाव पार्न सक्छ।"
    ],
    post2Heading8: "अन्तिम विचार: संतुलित दृष्टिकोण",
    post2Para12: "भविष्यका सर्जन र अनुसन्धानकर्ताको रूपमा, म प्रमाण-आधारित यौन स्वास्थ्य शिक्षालाई समर्थन गर्छु। मध्यमतामा अभ्यास गर्दा हस्तमैथुन विकासको स्वस्थ र सामान्य भाग हो।",
    post2Quote: "सही, कलंक-मुक्त शिक्षा प्रदान गरेर र तथ्यहरूसँग चिन्ताहरू सम्बोधन गरेर, हामी युवाहरूलाई आफ्नो शरीर र यौनताको स्वस्थ, अपराधबोध-मुक्त बुझाइ विकसित गर्न मद्दत गर्न सक्छौं।",
    backToPosts: "← लेखहरूमा फर्कनुहोस्"
  }
};
